module.exports = __webpack_public_path__ + "static/media/full_logo.88941f8c.png";